import type { RadioChangeEvent } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import EmptyState from '@features/regional-overview/digital-traps/components/empty-state';
import { FLIGHT_CURVE_GRAPH } from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { useFlightCurveStore } from '../flight-curve.zustand';
import { GraphFlightStage } from './graph-flight-stage/graph-flight-stage.component';
import { useGraphFlightStage } from './graph-flight-stage/use-graph-flight-stage.hook';
import { GraphHeader } from './graph-header/graph-header.component';
import { useFlightCurveGraph } from './graph.hook';
import { GraphContainer, GraphEmptyStateContainer } from './graph.styles';

export const Graph = () => {
  const { selectedDays, setSelectedDays, selectedTraps, selectedNetwork } = useFlightCurveStore();
  const { chartOptions } = useFlightCurveGraph();

  const { predictions, isPredictionsLoading, hasLegend } = useGraphFlightStage();

  const onChange = (e: RadioChangeEvent) => {
    const newDays = e.target.value as number;
    setSelectedDays(newDays);
  };

  if (!selectedNetwork || selectedTraps.length === 0) {
    return (
      <GraphEmptyStateContainer>
        <EmptyState context='flight_curve' />
      </GraphEmptyStateContainer>
    );
  }

  return (
    <GraphContainer data-testid={FLIGHT_CURVE_GRAPH}>
      <GraphHeader selectedNetwork={selectedNetwork.title} selectedDays={selectedDays} onDaysChange={onChange} />

      <div style={{ position: 'relative' }}>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />

        <GraphFlightStage selectedDays={selectedDays} predictions={predictions} isLoading={isPredictionsLoading} hasLegend={hasLegend} />
      </div>
    </GraphContainer>
  );
};
